export enum UserGroupTypes {
  TEAM_MEMBERSHIP = 'TEAM_MEMBERSHIP',
  ENTITY_MEMBERSHIP = 'ENTITY_MEMBERSHIP',
  DEALER_GROUP_MEMBERSHIP = 'DEALER_GROUP_MEMBERSHIP'
}